import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "History Upload Data Kartu Tercetak ")
  ])
], -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-start" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = {
  class: "col-5",
  style: {"text-align":"end"}
}
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Upload"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-75px; text-center" }, "Nama File"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Detail"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-2" }, "Aksi")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "row mt-5 mb-5" }
const _hoisted_25 = {
  style: {"z-index":"20001","margin-top":"40px"},
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_history_content",
  "data-bs-backdrop": "static"
}
const _hoisted_26 = { class: "modal-dialog modal-md" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Detail History Kartu ", -1)
const _hoisted_30 = { class: "svg-icon svg-icon-2x" }
const _hoisted_31 = {
  class: "modal-body row",
  style: {"padding-left":"35px"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, "Detail Status Upload", -1)
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_36 = { class: "col-7" }
const _hoisted_37 = { style: {"font-size":"12px"} }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Status ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_41 = { class: "col-7" }
const _hoisted_42 = { style: {"font-size":"12px"} }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Detail Status ")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_46 = { class: "col-7" }
const _hoisted_47 = { style: {"font-size":"12px"} }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container px-2 mt-3 mb-3" }, [
    /*#__PURE__*/_createElementVNode("hr", {
      style: {"width":"100%"},
      size: "5",
      color: "black"
    })
  ])
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, "Detail Data Kartu", -1)
const _hoisted_50 = { class: "row" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nama ")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_53 = { class: "col-7" }
const _hoisted_54 = { style: {"font-size":"12px"} }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 1 ")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_58 = { class: "col-7" }
const _hoisted_59 = { style: {"font-size":"12px"} }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 2 ")
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_63 = { class: "col-7" }
const _hoisted_64 = { style: {"font-size":"12px"} }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Tanggal Cetak ")
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_68 = { class: "col-7" }
const _hoisted_69 = { style: {"font-size":"12px"} }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container px-2 mt-3 mb-3" }, [
    /*#__PURE__*/_createElementVNode("hr", {
      style: {"width":"100%"},
      size: "5",
      color: "black"
    })
  ])
], -1)
const _hoisted_71 = { class: "row mt-5 mb-5" }
const _hoisted_72 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_history",
  "data-bs-backdrop": "static"
}
const _hoisted_73 = { class: "modal-dialog modal-xl" }
const _hoisted_74 = { class: "modal-content" }
const _hoisted_75 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Detail History ", -1)
const _hoisted_77 = { class: "svg-icon svg-icon-2x" }
const _hoisted_78 = { class: "modal-body row" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-3" }
const _hoisted_81 = { class: "d-flex align-items-center position-relative" }
const _hoisted_82 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_83 = { class: "col-3" }
const _hoisted_84 = { class: "d-flex align-items-center position-relative" }
const _hoisted_85 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_86 = { class: "col-3" }
const _hoisted_87 = {
  class: "col-3",
  style: {"text-align":"end"}
}
const _hoisted_88 = { class: "row" }
const _hoisted_89 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-75px; text-center" }, "Nomor Identitas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Detail"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_91 = { key: 0 }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_93 = { class: "text-center" }
const _hoisted_94 = { class: "text-center" }
const _hoisted_95 = { class: "text-center" }
const _hoisted_96 = { class: "text-center" }
const _hoisted_97 = { class: "text-center" }
const _hoisted_98 = ["onClick"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = { key: 1 }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, " Tidak Ada Data ")
], -1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = { class: "row mt-5 mb-5" }
const _hoisted_105 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_106 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_107 = ["label", "value"]
const _hoisted_108 = { class: "p-3" }
const _hoisted_109 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_110 = { class: "pagination" }
const _hoisted_111 = { class: "row mt-5 mb-5" }
const _hoisted_112 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_113 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_114 = ["label", "value"]
const _hoisted_115 = { class: "p-3" }
const _hoisted_116 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_117 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_date_picker, {
              "picker-options": _ctx.pickerOptions,
              modelValue: _ctx.dateAll,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateAll) = $event)),
              type: "daterange",
              "start-placeholder": "Tanggal Awal",
              "end-placeholder": "Tanggal Akhir",
              "value-format": "YYYY-MM-DD",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihTanggalAll()))
            }, null, 8, ["picker-options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Multiselect, {
              class: "mx-1",
              modelValue: _ctx.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
              placeholder: "Status",
              mode: "single",
              "create-option": false,
              options: _ctx.listStatus,
              searchable: true,
              label: "name",
              "track-by": "name",
              "value-prop": "_id",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihStatus($event)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "btn btn-primary",
              "data-bs-toggle": "modal",
              style: {"cursor":"pointer","margin-right":"10px"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
            }, " Reload Data "),
            _createElementVNode("a", {
              class: "btn btn-danger",
              "data-bs-toggle": "modal",
              style: {"cursor":"pointer"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/sekolah/card-design')))
            }, " Kembali ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.dateTime(item.createTime)), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(item.fileName), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(item.status), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.detail), 1),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.detailHistory(item))
                        }, _hoisted_20, 8, _hoisted_18)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_21, _hoisted_23))
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", {
                    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModalHistorySiswa && _ctx.closeModalHistorySiswa(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_30, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.detaildatasiswa.nis), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.detaildatasiswa.status), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _hoisted_45,
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.detaildatasiswa.detail), 1)
                    ])
                  ]),
                  _hoisted_48,
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _hoisted_52,
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.detaildatasiswacontent.nama), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _hoisted_57,
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.detaildatasiswacontent.nis), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _hoisted_62,
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.detaildatasiswacontent.nisn), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _hoisted_66,
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.detaildatasiswacontent.tanggal_cetak), 1)
                    ])
                  ]),
                  _hoisted_70
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("div", {
                    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                    onClick: _cache[7] || (_cache[7] = 
                    () => {
                      (_ctx.statusDetail = ''), (_ctx.namaDetail = ''), (_ctx.nisDetail = '');
                    }
                  )
                  }, [
                    _createElementVNode("span", _hoisted_77, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("span", _hoisted_82, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control ps-15",
                          placeholder: "Cari Nomor Identitas",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nisDetail) = $event)),
                          onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeNis(_ctx.e)))
                        }, null, 544), [
                          [_vModelText, _ctx.nisDetail]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("span", _hoisted_85, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control ps-15",
                          placeholder: "Cari Nama",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.namaDetail) = $event)),
                          onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePageSizeModal(_ctx.e)))
                        }, null, 544), [
                          [_vModelText, _ctx.namaDetail]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createVNode(_component_Multiselect, {
                        class: "mx-1",
                        modelValue: _ctx.statusDetail,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.statusDetail) = $event)),
                        placeholder: "Status",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.listStatusDetail,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "_id",
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.pilihStatusDetail($event)))
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("a", {
                        class: "btn btn-warning",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.downloadHistoryExcel()))
                      }, " Download ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("table", _hoisted_89, [
                      _hoisted_90,
                      (_ctx.tableDataHistoryDetail.length)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_91, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataHistoryDetail, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _hoisted_92,
                                _createElementVNode("td", _hoisted_93, _toDisplayString(item.nis), 1),
                                _createElementVNode("td", _hoisted_94, _toDisplayString(item.name), 1),
                                _createElementVNode("td", _hoisted_95, _toDisplayString(item.status), 1),
                                _createElementVNode("td", _hoisted_96, _toDisplayString(item.detail), 1),
                                _createElementVNode("td", _hoisted_97, [
                                  _createElementVNode("a", {
                                    class: "symbol symbol-35px me-2",
                                    "data-bs-toggle": "tooltip",
                                    title: "Detail",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.detailHistoryUpload(item))
                                  }, _hoisted_100, 8, _hoisted_98)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_101, _hoisted_103))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("select", {
                            name: "kt_customers_table_length",
                            class: "form-select form-select-sm form-select-solid",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pagingmodal.size) = $event)),
                            placeholder: "Per page",
                            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changePageSizeModal()))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagingmodal.perPageOptions, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item,
                                label: item,
                                value: item
                              }, null, 8, _hoisted_107))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.pagingmodal.size]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_108, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.pagingmodal.totalElements) + " entries ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("ul", _hoisted_110, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item previous", { disabled: _ctx.pagingmodal.page + 1 === 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            style: {"cursor":"pointer"},
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.prevPageModal && _ctx.prevPageModal(...args)))
                          }, " Previous ")
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item next", {
                          disabled:
                            _ctx.pagingmodal.page + 1 === _ctx.pagingmodal.totalPages,
                        }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            style: {"cursor":"pointer"},
                            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.nextPageModal && _ctx.nextPageModal(...args)))
                          }, " Next ")
                        ], 2)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_111, [
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_114))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_115, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("ul", _hoisted_117, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}